module.exports = __webpack_public_path__ + "ui-static/media/attention.541a7caa.mp3";